import Logo from './logo'
import Basic from './basic'
import Brands from './brands'
import Circular from './circular'
import CreditCards from './credit-cards'
import GiftCard from './gift-card'
import System from './system'
import Label from './labels'

export default {
  ...Logo,
  ...Basic,
  ...Brands,
  ...Circular,
  ...CreditCards,
  ...GiftCard,
  ...System,
  ...Label,
}



// WEBPACK FOOTER //
// ./common/components/icon/svg-list.js